import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { injectStyles } from 'injectStyles';
import { withRouter } from 'react-router-dom';
import SingleNavigationItem from '../NavigationItem';
import { isEmpty } from 'util/index';

class NavigationItems extends PureComponent {
  static defaultProps = {
    hasSmallDesktopMenu: false,
    navIsExpanded: false,
    isDesktopApp: false,
  };

  static propTypes = {
    classes: PropTypes.object.isRequired,
    navigationItems: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    hasSmallDesktopMenu: PropTypes.bool,
    isCollapsible: PropTypes.bool,
    navIsExpanded: PropTypes.bool,
    isDesktopApp: PropTypes.bool,
  };

  render() {
    const {
      classes,
      navigationItems,
      location,
      hasSmallDesktopMenu,
      isCollapsible,
      navIsExpanded,
      isDesktopApp,
    } = this.props;

    const getFilteredNavigationItems = (navigationItems) => {
      let filteredNavigationItems = navigationItems;

      if (isDesktopApp) {
        filteredNavigationItems = navigationItems.filter((item) => {
          return item?.pageLink?.slug !== 'apparaten';
        });
      }

      return filteredNavigationItems.map((navItem, index) => {
        return (
          <li key={`main-nav-${navItem.id}-${index}`}>
            <SingleNavigationItem
              hasSmallDesktopMenu={hasSmallDesktopMenu}
              navIsExpanded={navIsExpanded}
              location={location}
              isCollapsible={isCollapsible}
              {...navItem}
            />
          </li>
        );
      });
    };

    return <ul className={classes.list}>{!isEmpty(navigationItems) && getFilteredNavigationItems(navigationItems)}</ul>;
  }
}

const styles = (theme) => ({
  list: {
    backgroundColor: theme.palette.navigation.background,
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    zIndex: theme.zIndex.navigation + 4,
  },
});

// We wrap the NavigationItems in withRouter so that the location property becomes available
// When the location prop changes, the navigation items are re-rendered and become active/
export default withRouter(injectStyles(styles)(NavigationItems));
